import { useTranslation } from "react-i18next";
import PageHeader from "@/components/admin/header/PageHeader";
import { ExecuteTagAssignmentButton } from "@/components/admin/tag/ExecuteTagAssignmentButton";

const ExecuteTagAssignmentPage = () => {
  const { t } = useTranslation("admin");

  return (
    <>
      <PageHeader hasBack={false} title={t("tagAssignment.title")} />
      <h2 style={{ marginTop: 0 }}>{t("tagAssignment.execution")}</h2>
      <ExecuteTagAssignmentButton />
    </>
  );
};

export default ExecuteTagAssignmentPage;
